import { createFileRoute } from "@tanstack/react-router";
import { requireAuth } from "@/lib/auth";
import { AppLayout, PageTransition } from "@/components/layout";
import { Icon } from "@/components/ui/Icon";

export const Route = createFileRoute("/scenes/")({
  beforeLoad: requireAuth,
  component: ScenesPage,
});

function ScenesPage() {
  return (
    <AppLayout>
      <PageTransition>
        {/* Content - offset for floating sidebar on desktop */}
        <div className="p-6 lg:pl-20 min-h-[calc(100vh-72px)] flex items-center justify-center">
          <div className="text-center">
            <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-surface-2 flex items-center justify-center">
              <Icon name="circles" size={40} className="text-text-tertiary" />
            </div>
            <h1 className="text-h4 text-text-primary">Scenes</h1>
            <p className="text-body-1 text-text-secondary mt-2 max-w-md">
              Coming soon! Discover local scenes and communities near you.
            </p>
          </div>
        </div>
      </PageTransition>
    </AppLayout>
  );
}
